import * as React from 'react'
import { observer } from 'mobx-react'
import TaxRefundMethodViewModel from './../TaxRefundMethodViewModel'
import {
  CheckTaxRefundDeliveryMethod,
  DirectDepositTaxRefundDeliveryMethod,
  FutureTaxCreditTaxRefundDeliveryMethod,
  TaxRefundMethodVersion,
  TaxRefundType,
} from './../TaxRefundMethodVersion'

import { Section, SectionItem } from '../../components/Section'
import { PhysicalAddressSectionItems } from 'jobs/info-gathering/components/PhysicalAddress'

interface Props {
  vm: TaxRefundMethodViewModel
}

export default observer(function RefundInfo({ vm }: Props) {
  return (
    <>
      {vm.personalRefundMethod && (
        <Section title="Personal tax refund" bordered>
          <SectionItem
            label="Method"
            value={vm.personalRefundMethodDeliveryMethodDisplay}
          />
          <RefundMethodSection vm={vm.personalRefundMethod} />
        </Section>
      )}
      {vm.businessRefundMethod && (
        <Section title="Business tax refund" bordered>
          <SectionItem
            label="Method"
            value={vm.businessRefundMethodDeliveryMethodDisplay}
          />
          <RefundMethodSection vm={vm.businessRefundMethod} />
        </Section>
      )}
    </>
  )
})

interface RefundMethodSectionProps {
  vm: TaxRefundMethodVersion
}

function RefundMethodSection({ vm }: RefundMethodSectionProps) {
  return (
    <>
      {vm.deliveryMethod instanceof CheckTaxRefundDeliveryMethod && (
        <CheckTaxRefundDeliveryMethodSection
          vm={vm.deliveryMethod}
          refundType={vm.type}
        />
      )}

      {vm.deliveryMethod instanceof DirectDepositTaxRefundDeliveryMethod && (
        <DirectDepositTaxRefundDeliveryMethodSection vm={vm.deliveryMethod} />
      )}

      {vm.deliveryMethod instanceof FutureTaxCreditTaxRefundDeliveryMethod && (
        <FutureTaxCreditTaxRefundDeliveryMethodSection />
      )}
    </>
  )
}

interface CheckTaxRefundDeliveryMethodSectionProps {
  vm: CheckTaxRefundDeliveryMethod
  refundType?: TaxRefundType
}

function CheckTaxRefundDeliveryMethodSection({
  vm,
  refundType,
}: CheckTaxRefundDeliveryMethodSectionProps) {
  if (vm.mailingAddress) {
    return <PhysicalAddressSectionItems vm={vm.mailingAddress} />
  }

  if (refundType === TaxRefundType.Personal) {
    return (
      <SectionItem
        label="Address"
        value="Using same address as personal information."
        copyable={false}
      />
    )
  }

  if (refundType === TaxRefundType.Business) {
    return (
      <SectionItem
        label="Address"
        value="Using same address as business information."
        copyable={false}
      />
    )
  }

  return <></>
}

interface DirectDepositTaxRefundDeliveryMethodSectionProps {
  vm: DirectDepositTaxRefundDeliveryMethod
}

function DirectDepositTaxRefundDeliveryMethodSection({
  vm,
}: DirectDepositTaxRefundDeliveryMethodSectionProps) {
  return (
    <>
      <SectionItem
        label="Account type"
        value={vm.bankAccount?.accountType}
        isSensitive
      />

      <SectionItem
        label="Routing number"
        value={vm.bankAccount?.routingNumber}
        maskedValue={vm.bankAccount?.routingNumberDisplay}
        isSensitive
      />

      <SectionItem
        label="Account number"
        value={vm.bankAccount?.accountNumber}
        maskedValue={vm.bankAccount?.accountNumberDisplay}
        isSensitive
      />
    </>
  )
}

function FutureTaxCreditTaxRefundDeliveryMethodSection() {
  return <></>
}
